/**
 * Resta `months` meses a `date` clampeando el día al máximo del mes destino
 * (MOMSG-1078, WARNING Judgment Day, bug de fechas): `new Date(y, m - 3, d)`
 * sufre overflow de día-de-mes de JS — el 31 de mayo o el 31 de diciembre,
 * restar 3 meses cae en "31 de febrero"/"31 de septiembre" (no existen) y
 * `Date` rueda hacia adelante en vez de clampear, acortando el rango del
 * datepicker esos 2 días del año.
 *
 * Suggestion Judgment Day (punto 7): extraída a `lib-klab-core` — antes
 * estaba duplicada verbatim en `lib-klab-micros-dashboard-ui`
 * (`klab-chat.utils.ts`) y en `lib-klab-micros-chat-ui`
 * (`klab-chat-conversation.component.ts`), las dos superficies de búsqueda
 * de mensajes por rango de fecha (dashboard y widget). Ambas librerías ya
 * dependen de `lib-klab-core`, así que es el único punto en común real.
 */
export function subtractMonthsClamped(date: Date, months: number): Date {
  const originalDay = date.getDate();
  const firstOfTargetMonth = new Date(date.getFullYear(), date.getMonth() - months, 1);
  const daysInTargetMonth = new Date(
    firstOfTargetMonth.getFullYear(),
    firstOfTargetMonth.getMonth() + 1,
    0,
  ).getDate();
  firstOfTargetMonth.setDate(Math.min(originalDay, daysInTargetMonth));
  return firstOfTargetMonth;
}
